/* ================================================== */
/* SCROLL TO
/* ================================================== */

$(document).ready(function() {
	$('[data-scroll-to]').click(function(event) {
		event.preventDefault();
		var $target = $($(this).data('scroll-to')).first();
		if ($target.length) {
			var duration = Math.abs(($target.offset().top - $(window).scrollTop()) / 5),
				duration = (duration < 250) ? 250 : duration,
				duration = (duration > 800) ? 800 : duration;
			gsap.to(window, { duration: duration / 750, scrollTo: $target.offset().top, autoKill: false });
		}
	});
});